import { useTranslation } from "react-i18next";
import type { ExpertReviewSection } from "./expert-review.types";

type ExpertReviewBodyProps = {
	section: ExpertReviewSection;
};

export function ExpertReviewBody({ section }: ExpertReviewBodyProps) {
	const { t } = useTranslation("product");
	const sectionTestId = `review-section-${section.category.toLowerCase().replace(/\s+/g, "-")}`;

	return (
		<div
			className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg w-[242px] min-h-[225px]"
			data-testid={sectionTestId}
		>
			<h3 className="text-body-sm-emphasis text-ansay-400">
				{/* @ts-ignore - dynamic translation key */}
				{t(`expertReview.section.${section.category}`)}
			</h3>
			<p className="text-body-sm text-gray-600">{section.text}</p>
		</div>
	);
}
